/**
 * Text normalisation for the client-side search index (§10.1).
 *
 * Lowercase, Unicode NFD with combining marks stripped, whitespace collapsed,
 * punctuation removed except inner hyphens. This runs once per book at index
 * build time and once per keystroke on the query, so it stays allocation-light.
 */

const COMBINING_MARKS = /[̀-ͯ]/g
/** Uzbek uses ʻ and ʼ as letters, not punctuation — they must survive. */
const PUNCTUATION = /[^\p{L}\p{N}\s\-ʻʼ]/gu
const WHITESPACE = /\s+/g

export function normalize(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(COMBINING_MARKS, '')
    .replace(PUNCTUATION, ' ')
    .replace(WHITESPACE, ' ')
    .trim()
}

/** Splits a normalised string into search tokens, dropping empty fragments. */
export function tokenize(value: string): string[] {
  const normalized = normalize(value)
  return normalized.length === 0 ? [] : normalized.split(' ').filter(Boolean)
}
